<template>
  <div>
    <v-dialog v-model="dialog" max-width="85vw">
      <v-img
          :src=         "clickedImage"
          :contain=     "true"
          @click.stop=  "dialog=false"/>
    </v-dialog>
    <Table :properties="tableProperties">
      <template v-slot:imageUrl="{ item }">
        <v-img contain :src="item.imageUrl" width="5rem" @click="zoom(item.imageUrl)"></v-img>
      </template>
      <template v-slot:RDP_STOCKFLAG="{ item }">
        <v-chip label v-if="item.RDP_STOCKFLAG" color="green" text-color="white">
          <!-- {{item.BLIZ_STOCKQUANT}} {{$t('field.InStock')}} -->
          {{$t('field.InStock')}}
        </v-chip>
      </template>
      <template v-slot:YHV_SUBSTFLAG="{ item }">
        <v-chip label v-if="item.YHV_SUBSTFLAG" color="green" text-color="white">
          {{$t('field.HasReplacement')}}
        </v-chip>
      </template>
    </Table>
  </div>
</template>
<script>
  import { API }  from 'aws-amplify'
  import Table    from '../components/Table'

  export default {
    name:       'Parts',
    components: { Table },
    data() {
      return {
        dialog:       false,
        clickedImage: null,
        tableProperties: {
          items:        [],
          loading:      false,
          itemsPerPage: 100,
          headers: [
            { text: this.$t('field.PARTNAME'),  value: 'PARTNAME',          width: '25%', align: 'start'  },
            { text: this.$t('field.PARTDES'),   value: 'PARTDES'                                          },
            { text: this.$t('field.PRICE'),     value: 'PRICE',             width: '10%'                  },
            { text: '',                         value: 'RDP_STOCKFLAG',     width: '1%'                   },
            { text: '',                         value: 'YHV_SUBSTFLAG',     width: '1%'                   },
            { text: 0,                          value: 'BLIZ_STOCKQUANT',                                 },
            { text: '',                         value: 'imageUrl',          width: '100px'                },
          ],
          dynamicFieldsSlots: [ 'imageUrl', 'RDP_STOCKFLAG', 'YHV_SUBSTFLAG', 'BLIZ_STOCKQUANT' ]
        }
      }
    },
    methods: {
      zoom(url) {
        this.dialog       = true
        this.clickedImage = url;
      },
    },
    created() {
      if (this.$store.state.parts.length > 0) return

      this.tableProperties.loading = true
      API.get('priority', '/apiv1/parts').then(res => this.$store.commit('setParts', res))
    },
    watch:{
      "$store.state.parts": {
        handler: function(parts) {
          this.tableProperties.items    = parts
          this.tableProperties.loading  = false
        },
        immediate: true
      }
    }
  }
</script>
